import { getFunctionFormSchema as publicGetFunctionFormSchema } from './functions-v1-function-form-schema-function-form-schemas.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

/** @internal */
export const getFunctionFormSchema: MaybeContext<
  BuildRESTFunction<typeof publicGetFunctionFormSchema> &
    typeof publicGetFunctionFormSchema
> = /*#__PURE__*/ createRESTModule(publicGetFunctionFormSchema);

export { FormFieldSourceType } from './functions-v1-function-form-schema-function-form-schemas.universal.js';
export {
  FunctionFormSchema,
  FormFieldSource,
  GetFunctionFormSchemaRequest,
  GetFunctionFormSchemaResponse,
} from './functions-v1-function-form-schema-function-form-schemas.universal.js';
export { FormFieldSourceTypeWithLiterals } from './functions-v1-function-form-schema-function-form-schemas.universal.js';
